import { render, staticRenderFns } from "./EmitterReportTable.vue?vue&type=template&id=56608e81&scoped=true&"
import script from "./EmitterReportTable.vue?vue&type=script&lang=js&"
export * from "./EmitterReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56608e81",
  null
  
)

export default component.exports